import type { ReactElement } from 'react';
import { cloneElement, memo } from 'react';

import classNames from 'classnames';
import { merge } from 'lodash';

import { OneOrMany } from '@utilities/helpers/OneOrMany';

import type { Button, ButtonProps } from '../../../Button';
import styles from './DialogButtonGroup.module.scss';

interface DialogButtonGroupProps {
  minButtonWidth?: ButtonProps['minWidth'];
  children?: OneOrMany<ReactElement<ButtonProps, typeof Button>>;
}

const cloneButtonElement = (element: ReactElement<ButtonProps, typeof Button>, defaults: ButtonProps) => {
  return cloneElement(element, merge({}, defaults, element.props));
};

const DialogButtonGroup = memo(({ children = [], minButtonWidth }: DialogButtonGroupProps) => {
  const buttons =  [...OneOrMany.asArray(children)];
  const lastButton = buttons.pop();

  return (
    <div className={classNames(styles.container, 'buttons', { [styles['container-stretch_buttons']]: (minButtonWidth === undefined) })}>
      {
        buttons.map((button) => {
          return cloneButtonElement(button, { minWidth: minButtonWidth, variant: 'secondary' })
        })
      }

      {
        lastButton && (
          cloneButtonElement(lastButton, { minWidth: minButtonWidth, variant: 'primary' })
        )
      }
    </div>
  );
});

export {
  DialogButtonGroup,
  type DialogButtonGroupProps,
}
